module.exports = __webpack_public_path__ + "media/images/announceGroup__textBg-fc949aaa159b114f95f5a79ceac13c11.png";